import {CommonMessages} from '../common.messages';

export const PanelPaymentsEditMessages = {
    GetPaymentFailed: {
        key: 'GetPaymentFailed',
        message: 'Error while communication with the server. Unable to get details about the payment.'
    },
    PaymentNotFound: {
        key: 'PaymentNotFound',
        message: 'Error while communication with the server. Unable to find details about the payment.'
    },
    GetPaymentStatusTriggersFailed: {
        key: 'GetPaymentStatusTriggersFailed',
        message: 'Error while communication with the server. Unable to get payment status transition triggers.'
    },
    GetCountriesFailed: {
        key: 'GetCountriesFailed',
        message: 'Error while communication with the server. Unable to get information needed for displaying of the details about payment.'
    },
    GetCountriesInvalidData: {
        key: 'GetCountriesInvalidData',
        message: 'Error while communication with the server. Information needed for displaying of the payment details is invalid.'
    },
    UpdateAmountFailed: {
        key: 'UpdateAmountFailed',
        message: 'Error while server request. Unable to update payment amount.'
    },
    UpdateAdjustmentFailed: {
        key: 'UpdateAdjustmentFailed',
        message: 'Unable to update adjustment.'
    },
    UpdateAmountSucceeded: {
        key: 'UpdateAmountSucceeded',
        message: 'Payment is successfully updated.'
    },
    UpdateStatusFailed: {
        key: 'UpdateStatusFailed',
        message: 'Error while server request. Unable to change payment status.'
    },
    UpdateStatusToCancelledRejected: {
        key: 'UpdateStatusToCancelledRejected',
        message: 'Additional permissions are required for payments cancellation.'
    },
    UpdateStatusSucceeded: {
        key: 'UpdateStatusSucceeded',
        message: 'Payment status is successfully updated.'
    },
    BulkPaymentStatusChangeFailed: {
        key: 'BulkPaymentStatusChangeFailed',
        message: '<<total>> payment status change failed. Error while server request.'
    },
    BulkPaymentStatusChangeSucceeded: {
        key: 'BulkPaymentStatusChangeSucceeded',
        message: '<<total>> payment status is successfully updated.'
    },
    BulkPaymentStatusChangeFailedByUnavailableStatus: {
        key: 'BulkPaymentStatusChangeFailedByUnavailableStatus',
        message: '<<total>> payment cannot be moved to selected status.'
    },
    ...CommonMessages
};
